module.exports = __webpack_public_path__ + "img/serach.59cb6553.png";